import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type LoginMode = 'otp' | 'invite';

interface AuthState {
  loginMode: LoginMode | null;
  email: string;
  phone: string;
  inviteCode: string;
  otp: string;
  isAuthenticated: boolean;
  verifiedUser: any | null;
  setLoginMode: (m: LoginMode) => void;
  setEmail: (v: string) => void;
  setPhone: (v: string) => void;
  setInviteCode: (v: string) => void;
  setOtp: (v: string) => void;
  setVerifiedUser: (user: any) => void;
  authenticate: () => void;
  reset: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      loginMode: null,
      email: '',
      phone: '',
      inviteCode: '',
      otp: '',
      isAuthenticated: false,
      verifiedUser: null,
      setLoginMode: (m) => set({ loginMode: m }),
      setEmail: (v) => set({ email: v }),
      setPhone: (v) => set({ phone: v }),
      setInviteCode: (v) => set({ inviteCode: v }),
      setOtp: (v) => set({ otp: v }),
      setVerifiedUser: (user) => set({ verifiedUser: user }),
      authenticate: () => set({ isAuthenticated: true }),
      reset: () =>
        set({
          loginMode: null,
          email: '',
          phone: '',
          inviteCode: '',
          otp: '',
          isAuthenticated: false,
          verifiedUser: null,
        }),
    }),
    {
      name: 'auth-storage', // stores in localStorage
    },
  ),
);
